function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.461 10.358c-.733 0-1.406.275-1.914.732a4.8 4.8 0 0 1-2.501-2.5 2.86 2.86 0 0 0 .733-1.915 2.91 2.91 0 0 0-2.898-2.906A2.91 2.91 0 0 0 .975 6.675c0 5.243 4.243 9.478 9.486 9.478a2.9 2.9 0 0 0 2.906-2.898 2.91 2.91 0 0 0-2.906-2.898",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.483 0a7.54 7.54 0 0 0-5.551 2.434 4.17 4.17 0 0 1 2.22.67 5.553 5.553 0 0 1 8.881 4.434c0 1.236-.407 2.38-1.096 3.303a4.1 4.1 0 0 1 .756 2.147 7.53 7.53 0 0 0 2.333-5.45C17.027 3.383 13.644 0 9.484 0",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81 4.175c-.369 0-.668.3-.668.669v2.57c0 .37.299.67.669.67h1.794a.669.669 0 1 0 0-1.338H10.48V4.844a.67.67 0 0 0-.668-.669",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcService);
export default __webpack_public_path__ + "static/media/ic_Service.13321730fa6e2ab12cfb1a48c8afdb99.svg";
export { ForwardRef as ReactComponent };